module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('container', [_vm._v("\n    Runner's Data\n    "), _c('table', {
    staticStyle: {
      "width": "100%",
      "table-layout": "fixed",
      "height": "39.3rem"
    }
  }, [_c('td', {
    staticStyle: {
      "width": "25%"
    }
  }, [_c('tr'), _vm._v(" "), _c('tr', [_c('div', {
    staticClass: "profile-image-container"
  }, [(_vm.runner.imageUrl) ? _c('img', {
    staticClass: "profile-image",
    attrs: {
      "src": _vm.runner.imageUrl,
      "alt": "Profile"
    }
  }) : _c('div', {
    staticClass: "profile-placeholder"
  }, [_c('svg', {
    staticClass: "profile-icon",
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "12",
      "cy": "7",
      "r": "4"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "red",
      "padding-top": "3rem"
    }
  }, [_c('h1', {
    staticStyle: {
      "font-size": "large",
      "font-family": "sans-serif"
    }
  }, [_vm._v("CONFIDENTIAL")]), _vm._v(" "), _c('tr', [_vm._v("Mail address: " + _vm._s(_vm.runner.runner ? _vm.runner.runner.user.email : null))]), _vm._v(" "), _c('tr', [_vm._v("Height: " + _vm._s(_vm.runner.runner ? _vm.runner.runner.height : null))]), _vm._v(" "), _c('tr', [_vm._v("Weight: " + _vm._s(_vm.runner.runner ? _vm.runner.runner.weight : null))]), _vm._v(" "), _c('tr', [_c('button', {
    staticClass: "edit",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.openEmailEditModal()
      }
    }
  }, [_vm._v("EDIT email")])]), _vm._v(" "), _c('edit-email', {
    attrs: {
      "runner": _vm.runner,
      "show": _vm.showEmailModal
    },
    on: {
      "saved": _vm.onSavedEmail,
      "closed": _vm.onClosed
    }
  })], 1), _vm._v(" "), (this.runner.runner) ? _c('div', {
    staticStyle: {
      "margin-top": "101px"
    }
  }, [_c('tr', [_vm._v("Catchphrase")]), _vm._v(" "), (!_vm.editingCatchPhrase) ? _c('div', {
    staticClass: "field-display catchphrase-field"
  }, [_c('span', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.runner.runner.catchPhrase || 'No catchphrase set'))]), _vm._v(" "), _c('svg', {
    staticClass: "edit-icon",
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    },
    on: {
      "click": function($event) {
        _vm.startEditCatchPhrase()
      }
    }
  }, [_c('path', {
    attrs: {
      "d": "M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "m18.5 2.5 3 3L12 15l-4 1 1-4 9.5-9.5z"
    }
  })])]) : _c('div', {
    staticClass: "field-edit"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.runner.runner.catchPhrase),
      expression: "runner.runner.catchPhrase"
    }],
    staticClass: "catchphrase",
    attrs: {
      "type": "text",
      "id": "catchPhrase",
      "maxlength": "255",
      "name": "catchPhrase",
      "placeholder": "Enter catchphrase"
    },
    domProps: {
      "value": (_vm.runner.runner.catchPhrase)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.runner.runner, "catchPhrase", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('svg', {
    staticClass: "save-icon",
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    },
    on: {
      "click": function($event) {
        _vm.saveCatchPhrase()
      }
    }
  }, [_c('polyline', {
    attrs: {
      "points": "20,6 9,17 4,12"
    }
  })])])]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "35%"
    }
  }, [_c('tr', [_vm._v("Runner ID : " + _vm._s(_vm.runner.runner ? _vm.runner.runner.id : null))]), _vm._v(" "), _c('tr', [_vm._v("Runner Name : " + _vm._s(_vm.runner.runner ? _vm.runner.runner.firstName : null))]), _vm._v(" "), _c('tr', [_vm._v("Gender: " + _vm._s(_vm.runner.runner ? _vm.runner.runner.gender : null))]), _vm._v(" "), _c('tr', [_vm._v("Location: " + _vm._s(_vm.runner.runner ? _vm.runner.runner.lastName : null))]), _vm._v(" "), _c('tr', [_vm._v("URL:\n          "), _c('a', {
    attrs: {
      "href": _vm.runner.runner ? _vm.runner.runner.website : null,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.runner.runner ? _vm.runner.runner.website : null))])]), _vm._v(" "), _c('tr', [_vm._v("Profile: \n          "), (!_vm.editingProfileText) ? _c('div', {
    staticClass: "field-display"
  }, [_c('span', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.profileTexts || 'No profile text set'))]), _vm._v(" "), _c('svg', {
    staticClass: "edit-icon",
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    },
    on: {
      "click": function($event) {
        _vm.startEditProfileText()
      }
    }
  }, [_c('path', {
    attrs: {
      "d": "M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "m18.5 2.5 3 3L12 15l-4 1 1-4 9.5-9.5z"
    }
  })])]) : _c('div', {
    staticClass: "field-edit"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profileTextEdit),
      expression: "profileTextEdit"
    }],
    staticClass: "profile-text-area",
    attrs: {
      "maxlength": "500",
      "placeholder": "Enter profile text"
    },
    domProps: {
      "value": (_vm.profileTextEdit)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.profileTextEdit = $event.target.value
      }
    }
  }), _vm._v(" "), _c('svg', {
    staticClass: "save-icon",
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    },
    on: {
      "click": function($event) {
        _vm.saveProfileText()
      }
    }
  }, [_c('polyline', {
    attrs: {
      "points": "20,6 9,17 4,12"
    }
  })])])]), _vm._v(" "), _c('tr', [_vm._v("Total km: " + _vm._s(_vm.runner.totalDistance))]), _vm._v(" "), _c('tr', [_vm._v("Last Run: -")]), _vm._v(" "), _c('tr', [_vm._v("Days since last Run: " + _vm._s(_vm.runner.daysSinceLastClass))]), _vm._v(" "), _c('tr', [_vm._v("Last 30 days Best Rank: " + _vm._s(_vm.runner.bestPlaceCurrentMonth))]), _vm._v(" "), _c('tr', [_vm._v("Number of completed sessions: " + _vm._s(_vm.runner.totalRuns))]), _vm._v(" "), _c('tr', [_vm._v(" Gold " + _vm._s(_vm.Gold) + "     \n             Silver " + _vm._s(_vm.Silver) + "     \n             Bronze " + _vm._s(_vm.Bronze))]), _vm._v(" "), _c('tr', [_vm._v("Account created on: " + _vm._s(_vm.createdOn))]), _vm._v(" "), _c('tr', [_vm._v("ラン・ウォーク : " + _vm._s(_vm.runner.totalRuns))]), _vm._v(" "), _c('tr', [_vm._v("筋トレ : " + _vm._s(_vm.runner.totalCountIndoorTraining))]), _vm._v(" "), _c('tr', [_vm._v("ストレッチ : " + _vm._s(_vm.runner.totalCountStretch))]), _vm._v(" "), _c('tr', [_vm._v("ヨガ : " + _vm._s(_vm.runner.totalCountYoga))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('tr', {
    staticStyle: {
      "height": "65px",
      "margin-top": "10px"
    }
  }, [_vm._v("Memo     \n          "), (!_vm.editingMemo) ? _c('div', {
    staticClass: "field-display"
  }, [_c('span', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.memo || 'No memo set'))]), _vm._v(" "), _c('svg', {
    staticClass: "edit-icon",
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    },
    on: {
      "click": function($event) {
        _vm.startEditMemo()
      }
    }
  }, [_c('path', {
    attrs: {
      "d": "M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "m18.5 2.5 3 3L12 15l-4 1 1-4 9.5-9.5z"
    }
  })])]) : _c('div', {
    staticClass: "field-edit"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.memo),
      expression: "memo"
    }],
    staticClass: "memo",
    attrs: {
      "id": "memo",
      "maxlength": "255",
      "name": "memo",
      "placeholder": "Enter memo"
    },
    domProps: {
      "value": (_vm.memo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.memo = $event.target.value
      }
    }
  }), _vm._v(" "), _c('svg', {
    staticClass: "save-icon",
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    },
    on: {
      "click": function($event) {
        _vm.saveMemo()
      }
    }
  }, [_c('polyline', {
    attrs: {
      "points": "20,6 9,17 4,12"
    }
  })])])]), _vm._v(" "), _c('tr', {
    staticClass: "runner-tags"
  }, [_c('div', {
    staticClass: "tags-container"
  }, [_c('p', {
    staticClass: "tags-label"
  }, [_vm._v("Tags")]), _vm._v(" "), _c('selectize', {
    staticStyle: {
      "visibility": "hidden"
    },
    attrs: {
      "options": _vm.options,
      "multiple": "",
      "size": "1",
      "runnerid": this.$props.runnerId,
      "isRunnerTag": true,
      "data-dropdown-parent": "body",
      "data-max-options": "100",
      "data-value-field": "id",
      "data-label-field": "name",
      "data-search-field": "name",
      "data-sort-field": "name"
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })], 1)]), _vm._v(" "), _c('tr', {
    staticClass: "promocode-tags"
  }, [_c('div', {
    staticClass: "tags-container"
  }, [_c('p', {
    staticClass: "tags-label"
  }, [_vm._v("Promo Code Tags")]), _vm._v(" "), _c('selectize', {
    staticStyle: {
      "visibility": "hidden"
    },
    attrs: {
      "options": _vm.options,
      "multiple": "",
      "size": "1",
      "runnerid": this.$props.runnerId,
      "isPromoCodeTag": true,
      "data-dropdown-parent": "body",
      "data-max-options": "100",
      "data-value-field": "id",
      "data-label-field": "name",
      "data-search-field": "name",
      "data-sort-field": "name"
    },
    model: {
      value: (_vm.selectedPromoTags),
      callback: function($$v) {
        _vm.selectedPromoTags = $$v
      },
      expression: "selectedPromoTags"
    }
  })], 1)])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "40%"
    }
  }, [_c('table', {
    staticClass: "best"
  }, [_c('div', [_c('td', {
    staticStyle: {
      "padding": "0px 7px 0 7px"
    }
  }, [_c('tr', {
    staticClass: "topTr"
  }), _vm._v(" "), _c('tr', {
    staticClass: "trh",
    staticStyle: {
      "color": "rgb(60, 55, 185)"
    }
  }, [_c('span', {
    staticStyle: {
      "line-height": "25px"
    }
  }, [_vm._v(" 20 min ")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('br'), _vm._v(" "), _c('tr', {
    staticClass: "trh",
    staticStyle: {
      "color": "rgb(60, 55, 185)"
    }
  }, [_c('span', {
    staticStyle: {
      "line-height": "25px"
    }
  }, [_vm._v(" 30 min ")])]), _vm._v(" "), _c('hr'), _c('br'), _vm._v(" "), _c('tr', {
    staticClass: "trh",
    staticStyle: {
      "color": "rgb(60, 55, 185)"
    }
  }, [_c('span', {
    staticStyle: {
      "line-height": "25px"
    }
  }, [_vm._v(" 40 min ")])]), _vm._v(" "), _c('hr'), _c('br'), _vm._v(" "), _c('tr', {
    staticClass: "trh",
    staticStyle: {
      "color": "rgb(60, 55, 185)"
    }
  }, [_c('span', {
    staticStyle: {
      "line-height": "25px"
    }
  }, [_vm._v(" 60 min ")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "0px 20px 0 20px"
    }
  }, [_c('tr', {
    staticClass: "topTr",
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("Best " + _vm._s(_vm.currentYear))]), _vm._v(" "), _c('tr', {
    staticClass: "trh"
  }, _vm._l((_vm.currentYearbest[20]), function(best) {
    return (_vm.currentYearbest[20]) ? _c('span', {
      staticStyle: {
        "line-height": "25px"
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.date(_vm.convertToLocal(best.raceResume.finishDate))))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "padding-left": "2rem"
      }
    }, [_vm._v(" " + _vm._s((best.distance / 1000).toFixed(2)) + "km")]), _vm._v(" "), _c('br')]) : _vm._e()
  })), _vm._v(" "), _c('hr'), _c('br'), _vm._v(" "), _c('tr', {
    staticClass: "trh"
  }, _vm._l((_vm.currentYearbest[30]), function(best) {
    return (_vm.currentYearbest[30]) ? _c('span', {
      staticStyle: {
        "line-height": "25px"
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.date(_vm.convertToLocal(best.raceResume.finishDate))))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "padding-left": "2rem"
      }
    }, [_vm._v(" " + _vm._s((best.distance / 1000).toFixed(2)) + "km")]), _c('br')]) : _vm._e()
  })), _vm._v(" "), _c('hr'), _c('br'), _vm._v(" "), _c('tr', {
    staticClass: "trh"
  }, _vm._l((_vm.currentYearbest[40]), function(best) {
    return (_vm.currentYearbest[40]) ? _c('span', {
      staticStyle: {
        "line-height": "25px"
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.date(_vm.convertToLocal(best.raceResume.finishDate))))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "padding-left": "2rem"
      }
    }, [_vm._v(" " + _vm._s((best.distance / 1000).toFixed(2)) + "km")]), _c('br')]) : _vm._e()
  })), _vm._v(" "), _c('hr'), _c('br'), _vm._v(" "), _c('tr', {
    staticClass: "trh"
  }, _vm._l((_vm.currentYearbest[60]), function(best) {
    return (_vm.currentYearbest[60]) ? _c('span', {
      staticStyle: {
        "line-height": "25px"
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.date(_vm.convertToLocal(best.raceResume.finishDate))))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "padding-left": "2rem"
      }
    }, [_vm._v(" " + _vm._s((best.distance / 1000).toFixed(2)) + "km")]), _c('br')]) : _vm._e()
  }))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "background-color": "#c3c5cc",
      "border-radius": "10px",
      "padding": "0 15px 0 15px"
    }
  }, [_c('tr', {
    staticClass: "topTr",
    staticStyle: {
      "text-align": "center",
      "font-weight": "bold"
    }
  }, [_vm._v("All time")]), _vm._v(" "), _c('tr', {
    staticClass: "trh"
  }, _vm._l((_vm.best[20]), function(bestrec) {
    return (_vm.best[20]) ? _c('span', {
      staticStyle: {
        "line-height": "25px"
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.date(_vm.convertToLocal(bestrec.raceResume.finishDate))))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "padding-left": "2rem"
      }
    }, [_vm._v(" " + _vm._s((bestrec.distance / 1000).toFixed(2)) + "km")]), _vm._v(" "), _c('br')]) : _vm._e()
  })), _vm._v(" "), _c('hr'), _c('br'), _vm._v(" "), _c('tr', {
    staticClass: "trh"
  }, _vm._l((_vm.best[30]), function(bestrec) {
    return (_vm.best[30]) ? _c('span', {
      staticStyle: {
        "line-height": "25px"
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.date(_vm.convertToLocal(bestrec.raceResume.finishDate))))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "padding-left": "2rem"
      }
    }, [_vm._v(" " + _vm._s((bestrec.distance / 1000).toFixed(2)) + "km")]), _c('br')]) : _vm._e()
  })), _vm._v(" "), _c('hr'), _c('br'), _vm._v(" "), _c('tr', {
    staticClass: "trh"
  }, _vm._l((_vm.best[40]), function(bestrec) {
    return (_vm.best[40]) ? _c('span', {
      staticStyle: {
        "line-height": "25px"
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.date(_vm.convertToLocal(bestrec.raceResume.finishDate))))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "padding-left": "2rem"
      }
    }, [_vm._v(" " + _vm._s((bestrec.distance / 1000).toFixed(2)) + "km")]), _c('br')]) : _vm._e()
  })), _vm._v(" "), _c('hr'), _c('br'), _vm._v(" "), _c('tr', {
    staticClass: "trh"
  }, _vm._l((_vm.best[60]), function(bestrec) {
    return (_vm.best[60]) ? _c('span', {
      staticStyle: {
        "line-height": "25px"
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.date(_vm.convertToLocal(bestrec.raceResume.finishDate))))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "padding-left": "2rem"
      }
    }, [_vm._v(" " + _vm._s((bestrec.distance / 1000).toFixed(2)) + "km")]), _c('br')]) : _vm._e()
  }))])])]), _vm._v(" "), _c('tr'), _vm._v(" "), _c('tr', {
    staticStyle: {
      "height": "50px"
    }
  }, [_vm._v("CM Memo   \n        "), (!_vm.editingCMMemo) ? _c('div', {
    staticClass: "field-display"
  }, [_c('span', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.cmmemo || 'No CM memo set'))]), _vm._v(" "), _c('svg', {
    staticClass: "edit-icon",
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    },
    on: {
      "click": function($event) {
        _vm.startEditCMMemo()
      }
    }
  }, [_c('path', {
    attrs: {
      "d": "M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "m18.5 2.5 3 3L12 15l-4 1 1-4 9.5-9.5z"
    }
  })])]) : _c('div', {
    staticClass: "field-edit"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cmmemo),
      expression: "cmmemo"
    }],
    staticClass: "cmmemo",
    attrs: {
      "id": "cmmemo",
      "maxlength": "2000",
      "name": "cmmemo",
      "placeholder": "Enter CM memo"
    },
    domProps: {
      "value": (_vm.cmmemo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cmmemo = $event.target.value
      }
    }
  }), _vm._v(" "), _c('svg', {
    staticClass: "save-icon",
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    },
    on: {
      "click": function($event) {
        _vm.saveCMMemo()
      }
    }
  }, [_c('polyline', {
    attrs: {
      "points": "20,6 9,17 4,12"
    }
  })])])])])]), _vm._v(" "), (this.$route.query.runmetrix == 1) ? _c('div', [(this.$route.query.runmetrix == 1) ? _c('run-metrix', {
    attrs: {
      "runmetrix": _vm.runmetrixData,
      "runnerId": this.$props.runnerId
    }
  }) : _vm._e()], 1) : _c('div', [_c('div', [_c('router-link', {
    staticClass: "runmetrix_btn",
    attrs: {
      "to": {
        name: 'runner-data',
        params: {
          runnerId: this.$props.runnerId
        },
        query: {
          runmetrix: 1
        }
      },
      "target": "_blank"
    }
  }, [_vm._v("\n            Runmetrix\n        ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "add_race"
  }, [_c('img', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "src": require("../../../assets/add-race.png"),
      "alt": "Add Race"
    },
    on: {
      "click": function($event) {
        _vm.addRace()
      }
    }
  }), _c('span', [_vm._v("Add a race")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-left": "2rem",
      "padding-top": "1px"
    }
  }, [_vm._v("  履歴 Past Runs")]), _vm._v(" "), _c('v-table', {
    staticStyle: {
      "width": "100%",
      "font-size": "10.5px"
    },
    attrs: {
      "is-horizontal-resize": "",
      "vertical-resize-offset": 60,
      "multiple-sort": false,
      "is-loading": _vm.isLoading,
      "even-bg-color": "#f2f2f2",
      "column-cell-class-name": _vm.columnCellClass,
      "columns": _vm.tableConfig.columns,
      "table-data": _vm.tableConfig.tableData,
      "paging-index": (_vm.pageIndex - 1) * _vm.pageSize
    },
    on: {
      "on-custom-comp": _vm.customCompFunc
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mt20 mb20 bold"
  }, [_c('v-pagination', {
    attrs: {
      "total": _vm.pageTotal,
      "page-size": _vm.pageSize,
      "layout": ['total', 'prev', 'pager', 'next', 'sizer', 'jumper']
    },
    on: {
      "page-change": _vm.pageChange,
      "page-size-change": _vm.pageSizeChange
    }
  })], 1), _vm._v(" "), _c('edit-distance', {
    attrs: {
      "race": _vm.raceData,
      "show": _vm.showModal
    },
    on: {
      "saved": _vm.onSaved,
      "closed": _vm.onClosed
    }
  }), _vm._v(" "), _c('add-race-data', {
    attrs: {
      "race": _vm.raceData,
      "runnerId": this.$props.runnerId,
      "show": _vm.showAddRaceModal
    },
    on: {
      "saved": _vm.onSavedRace,
      "closed": _vm.onClosed
    }
  })], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-39ad85e4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LiveRun/Race/RunnerData.vue
// module id = 1663
// module chunks = 1